import React from 'react';

const Contact = () => {
    return (
        <div className="fullContainerWidth">
            <div className="dflex">

                <div className="asider">


                </div>
                <div className="containerp">

                    <div className="gallery-grid">

                        <div className=' large info-text'>
                            <h1>Contactez-nous</h1>
                            <p>Chez To Create, nous croyons que chaque échange est une opportunité de donner vie à vos idées. Vous avez un projet en tête, une question ou simplement envie d'en savoir plus sur nos services ? Nous sommes à votre écoute.
                            </p>

                            <h3>
                                Comment nous joindre ?
                            </h3>
                            <p >
                                Email : <a style={{textDecoration:"none", fontWeight:'bold'}} href="mailto:contact@tocreate.fr">contact@tocreate.fr</a>
                            </p>
                            <p>
                                Téléphone : +33 6 52 80 29 37
                            </p>
                        </div>
                        <div className='grid-item haute'>
                            <img alt={' '} src="https://i.pinimg.com/736x/f4/43/99/f44399e8a26bb83d6e35a689d7be619e.jpg"  className="grid-image" />
                        </div>
                        <div  className='large' >


                        </div>



                        <div key='1' className='grid-item large' >

                        </div>


                    </div>

                </div>


            </div>
        </div>
    );
};

export default Contact;
